module.exports = __webpack_public_path__ + "img/posture.7785c511.png";